export type SubscriptionTypeImagesTypes = {
    Creche: string;
    CableTV: string;
    Preschool: string;
    Rentals: string;
    Tuition: string;
    Sports: string;
    Other: string;
    Fitness: string
};


export const SubscriptionTypeImages:SubscriptionTypeImagesTypes = {

    Tuition: "https://firebasestorage.googleapis.com/v0/b/coachprodev.appspot.com/o/Config%2FTution-Icon-.png?alt=media&token=02a38dfd-c01a-408a-a889-2582df271183",
    Sports: "https://firebasestorage.googleapis.com/v0/b/coachprodev.appspot.com/o/Config%2Fsports%20copy.jpg?alt=media&token=326c9450-8a9b-4397-a38b-16c44b347345",
    Rentals: "https://firebasestorage.googleapis.com/v0/b/coachprodev.appspot.com/o/Config%2Frental%20copy.png?alt=media&token=b2f376b5-2a42-44fe-a936-0e1d7f8456b7",
    Preschool: "https://firebasestorage.googleapis.com/v0/b/coachprodev.appspot.com/o/Config%2Fplayschool.jpg?alt=media&token=45da68dc-2dfe-49b2-bedb-271817ba1bf1",
    Other: "https://firebasestorage.googleapis.com/v0/b/coachprodev.appspot.com/o/Config%2Fother.jpg?alt=media&token=4bf20414-d64b-4074-b7f2-beb67c1b0c51",
    Fitness: "https://firebasestorage.googleapis.com/v0/b/coachprodev.appspot.com/o/Config%2Ffitness.jpg?alt=media&token=218a61f9-a7fb-4453-a4e8-5c5c9e8b3961",
    Creche: "https://firebasestorage.googleapis.com/v0/b/coachprodev.appspot.com/o/Config%2Fcreche.jpg?alt=media&token=d605f2d5-ce3b-44cb-9fca-71f3ee08d704",
    CableTV: "https://firebasestorage.googleapis.com/v0/b/coachprodev.appspot.com/o/Config%2Fcabletv-small.png?alt=media&token=ff4904c7-86e0-4ec2-beee-58be31d475fc"
};